import React from "react";
import { ArrowUpRight } from "lucide-react";

export default function DeveloperPage() {
  return (
    <div className="dev-page">
      <div className="dev-hero">
        <div className="dev-hero-badge">Developer API</div>
        <h1 className="dev-hero-title">BESC Bridge API</h1>
        <p className="dev-hero-sub">
          Programmatic bridge access for arbitrage bots, aggregators, and institutional integrations.
          <br />
          All access is reviewed and issued manually — no self-serve keys.
        </p>
      </div>

      <div className="dev-signup-card">
        <div className="dev-signup-header">
          <div>
            <div className="dev-signup-title">API Access — By Approval Only</div>
            <div className="dev-signup-sub">
              Submit a request with your project name, use case, and expected traffic. We review within 48 hours.
            </div>
          </div>
        </div>
        <div className="dev-key-result">
          <p className="dev-text-muted" style={{ marginBottom: "16px" }}>
            API keys are not available self-serve. Once approved, you will receive your key and
            full integration documentation directly.
          </p>
          <a
            className="dev-btn-primary"
            href="mailto:support@besc.services?subject=API Key Request"
            style={{ display: "inline-block", textDecoration: "none", textAlign: "center" }}
          >
            Request API Access →
          </a>
        </div>
      </div>

      <div className="dev-tiers">
        <div className="dev-section-title">Access Tiers</div>
        <div className="dev-tier-grid">
          {[
            { name: "Standard",   color: "#2dd4bf", desc: "Testing, analytics, small integrations" },
            { name: "Pro",        color: "#f59e0b", desc: "Production bots and aggregators", badge: "Popular" },
            { name: "Enterprise", color: "#a78bfa", desc: "Institutional and high-volume use" },
          ].map((tier) => (
            <div className="dev-tier-card" key={tier.name} style={{ borderColor: `${tier.color}33` }}>
              {tier.badge && (
                <div className="dev-tier-badge-pill" style={{ background: tier.color }}>{tier.badge}</div>
              )}
              <div className="dev-tier-name" style={{ color: tier.color }}>{tier.name}</div>
              <div className="dev-tier-desc">{tier.desc}</div>
              <a
                className="dev-tier-cta-link"
                href="mailto:support@besc.services?subject=API Access Request"
                style={{ textDecoration: "none", display: "inline-block" }}
              >
                Request access →
              </a>
            </div>
          ))}
        </div>
      </div>

      <div className="dev-upgrade-card">
        <div className="dev-upgrade-header">
          <div>
            <div className="dev-upgrade-title">How to Apply</div>
            <div className="dev-upgrade-sub">Keys issued manually · Documentation sent on approval</div>
          </div>
        </div>
        <p className="dev-text-muted" style={{ marginBottom: "16px" }}>
          Email us at <strong>support@besc.services</strong> with:
        </p>
        <ul style={{ color: "rgba(248,243,231,0.6)", fontSize: "14px", lineHeight: "2", paddingLeft: "20px", marginBottom: "20px" }}>
          <li>Your project name and a brief description</li>
          <li>Your intended use case</li>
          <li>Expected daily request volume</li>
          <li>A contact handle (Telegram or email)</li>
        </ul>
        <a
          className="dev-btn-primary"
          href="mailto:support@besc.services?subject=API Access Request"
          style={{ display: "inline-block", textDecoration: "none", textAlign: "center" }}
        >
          Contact for Access →
        </a>
      </div>

      <div className="dev-support">
        <div className="dev-support-text">Questions or need priority support? Reach us on Telegram.</div>
        <a
          href="https://t.me/buildersedgeportal"
          target="_blank"
          rel="noopener noreferrer"
          className="dev-btn-outline"
        >
          Telegram Support <ArrowUpRight size={14} style={{ verticalAlign: "middle" }} />
        </a>
      </div>
    </div>
  );
}
